<fullscreen-page>
  <content-column look="dark">
    <logo
      slot="toolbar"
      [routerLink]="['/']"
      look="dark"
      route="['/catalogs']">
    </logo>

    <div slot="content" class="login-layout">
      <div class="login-header">
        <div class="login-header-left">
          <a [routerLink]="['/']">
            <img alt="nextPim Pim System" height="50" src="/images/nextpim logo_transp_weiß_2.svg" class="login-header-logo" style="margin-left: 6px" />
          </a>
        </div>

        <div class="login-header-center">
          {{ 'Login' | translate }}
        </div>

        <div class="login-header-right">
          <a class="login-header-support" href="mailto:support@nextpim.de">?</a>
        </div>
      </div>

      <div class="login-content">
        <div class="login-page">
          <form class="login-form w-100" (submit)="onLogin()">
            <div class="dx-fieldset">
              <div class="dx-fieldset-header">
                {{ 'Login' | translate }}
              </div>

              <div class="dx-field">
                <div class="dx-field-label">
                  {{ 'Email' | translate }}
                </div>
                <div class="dx-field-value">
                  <dx-text-box
                    [(value)]="creds.username"
                    [showClearButton]="true"
                    width="100%">
                    <dx-validator>
                      <dxi-validation-rule
                        type="required"
                        message="{{ 'Bitte geben Sie Ihre Emailadresse ein' | translate }}.">
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>

              <div class="dx-field">
                <div class="dx-field-label">
                  {{ 'Passwort' | translate }}
                </div>
                <div class="dx-field-value">
                  <dx-text-box
                    [(value)]="creds.password"
                    mode="password"
                    [showClearButton]="true"
                    width="100%">
                    <dx-validator>
                      <dxi-validation-rule
                        type="required"
                        message="{{ 'Bitte geben Sie Ihr Passwort ein' | translate }}.">
                      </dxi-validation-rule>
                    </dx-validator>
                  </dx-text-box>
                </div>
              </div>

              <dx-validation-summary id="summary"></dx-validation-summary>

              <div class="dx-field login-actions">
                <div class="dx-field-value">
                  <a
                    class="forgotPassword"
                    [routerLink]="['/forgotPassword']">
                    {{ 'Passwort vergesssen' | translate }}?
                  </a>

                  <dx-button
                    class="login-button"
                    stylingMode="contained"
                    type="default"
                    text="{{ 'Login' | translate }}"
                    [useSubmitBehavior]="true">
                  </dx-button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </content-column>
</fullscreen-page>
